<template>
  <app-page-subsection
    v-if="course.outcomes.length > 0"
    id="outcomes"
    class="@container"
    :title="{ tag: 'h3', text: $t('course.page.outcomes_title') }"
  >
    <ol
      class="relative flex snap-x snap-proximity gap-4 overflow-x-auto pt-11 @md:grid-cols-2 @lg:grid @4xl:grid-cols-4"
    >
      <li
        v-for="(outcome, index) in course.outcomes"
        :key="outcome"
        class="relative shrink-0 basis-[300px] snap-start rounded-lg bg-primary-50 px-6 pb-4 pt-10"
      >
        <span
          aria-hidden="true"
          class="absolute -top-5 left-6 text-5xl font-bold text-primary"
          >{{ index + 1 }}.</span
        >
        <app-text-markdown lazy :value="outcome" />
      </li>
    </ol>
  </app-page-subsection>
</template>

<script lang="ts" setup>
defineProps<{
  course: Pick<DatabaseTable<"courses">, "outcomes">;
}>();
</script>
